import { render } from "./Avalie.vue?vue&type=template&id=63c6c79d&scoped=true"
import script from "./Avalie.vue?vue&type=script&lang=js"
export * from "./Avalie.vue?vue&type=script&lang=js"

import "./Avalie.vue?vue&type=style&index=0&id=63c6c79d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c6c79d"]])

export default __exports__